import { render, staticRenderFns } from "./WallMenu.vue?vue&type=template&id=4203e26b&"
import script from "./WallMenu.vue?vue&type=script&lang=js&"
export * from "./WallMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports